// LMS module player enums — ported from composable `lcModuleConstants.jsx`
// (SFCC-11505). `as const` so the union types are usable across the block.

export const quizStatuses = {
  OPEN: "open",
  PASSED: "passed",
  FAILED: "failed",
} as const;
export type QuizStatus = (typeof quizStatuses)[keyof typeof quizStatuses];

export const ctaTypes = {
  NEXT_GOAL: "next-goal",
  RETURN_TO_GOAL: "return-to-goal",
  NEXT_MODULE: "next-module",
} as const;
export type CtaType = (typeof ctaTypes)[keyof typeof ctaTypes];
